




























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Menu from '@/components/common/Menu.vue';
import VirtualMachineActions from '@/components/virtual-machine-edit/VirtualMachineActions.vue';
import VirtualMachineStats from '@/components/virtual-machine-edit/VirtualMachineStats.vue';
import { virtualMachineDetailsService } from '@/components/virtual-machine-edit/services/VirtualMachineDetailsService';
import { format } from 'date-fns';
import { mapState } from 'vuex';
import EventBus from '@/EventBus';

@Component({
  components: {
    Menu,
    VirtualMachineActions,
    VirtualMachineStats,
  },
  computed: {
    ...mapState({
      userRole: (state: any) => state.currentWorkspace.role,
      workspaceData: (state: any) =>
        state.workspaces.workspaces.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentWorkspace.id, 10)
        ) || {},
    }),
  },
})
export default class VirtualMachineInfo extends Vue {
  workspaceId = 0;
  regionId = 0;
  virtualMachineId = 0;
  orginalName = '';
  orginalDescription = '';
  isMachineNameEmpty = false;
  virtualMachine: any = {
    operating_system: {
      name: '',
    },
  };
  privateIpAddresses = [];
  publicIpAddresses = [];
  isEditingNameHidden = true;
  isLoading = false;

  @Watch('$store.state.virtualMachines.virtualMachines', { immediate: true, deep: true })
  onMachinesChange() {
    if (this.virtualMachineId) {
      const machineData = JSON.parse(
        JSON.stringify(this.$store.getters['virtualMachines/getMachine'](this.virtualMachineId))
      );
      if (machineData) {
        this.virtualMachine = machineData;
        this.orginalName = machineData.name;
        this.orginalDescription = machineData.description;
        this.privateIpAddresses = machineData.private_ip_addresses || [];
        this.publicIpAddresses = machineData.public_ip_addresses || [];
      }
    }
  }

  editVirtualMachineName() {
    if (this.virtualMachine.name === '') {
      this.isMachineNameEmpty = true;
    } else {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      virtualMachineDetailsService
        .editVirtualMachineDetails(this.workspaceId, this.regionId, this.virtualMachineId, {
          name: this.virtualMachine.name,
          description: this.orginalDescription,
        })
        .then(() => {
          this.isLoading = false;
          this.isEditingNameHidden = true;
          this.orginalName = this.virtualMachine.name;
        })
        .catch(() => {
          this.isLoading = false;
        });
    }
  }

  formatDate(date: string) {
    return date ? format(new Date(date), 'dd.MM.yyyy') : '';
  }
  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.virtualMachineId = parseInt(this.$route.params.virtualMachineId, 10);
    this.getVirtualMachine();
    EventBus.$on('virtual-machine-destroyed', (id: any) => {
      if (parseInt(id, 10) === this.virtualMachineId) {
        this.$router.push(`/workspaces/${this.workspaceId}/regions/${this.regionId}`).catch(() => {});
      }
    });
    EventBus.$on('backup_activated', () => {
      this.getVirtualMachine();
    });
  }
  cancelName() {
    this.isEditingNameHidden = !this.isEditingNameHidden;
    this.virtualMachine.name = this.orginalName;
    this.isMachineNameEmpty = false;
  }
  getVirtualMachine() {
    this.$store.dispatch('virtualMachines/getMachine', { machineId: this.virtualMachineId, forceUpdate: true });
  }
}
